import { ModalConfirm } from 'mailup-web-components'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'

export const ModalDelete = ({ show, name, handleCancel, handleConfirm }) => {
  const intl = useIntl()

  return (
    <ModalConfirm
      show={show}
      title={intl.formatMessage(
        {
          id: 'Load.AutomationWorkflow.ModalTitleDelete'
        },
        {
          name
        }
      )}
      message={intl.formatMessage({
        id: 'Load.AutomationWorkflow.ModalDeleteParagraph'
      })}
      stringCancel={intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
      stringConfirm={intl.formatMessage({ id: 'Load.MailupCommon.Delete' })}
      onClickCancel={handleCancel}
      onClickConfirm={handleConfirm}
      variant='delete'
    />
  )
}

ModalDelete.propTypes = {
  show: PropTypes.bool,
  name: PropTypes.string,
  handleCancel: PropTypes.func,
  handleConfirm: PropTypes.func
}
